// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label.more-label{right:10px;background:#f0f0f0;padding:0 10px;border-radius:5px;color:grey;box-shadow:-4px 0 4px #fff}.fa-angle-down,label.more-label{position:absolute;top:50%;transform:translateY(-50%)}.fa-angle-down{right:15px;font-size:17px;color:#999}", ""]);
// Exports
module.exports = exports;
